import { z } from 'zod';

const MAX_FIELD_LENGTH = 255;

export const authorSchema = z.object({
  id: z.number(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  organisation: z.string().nullable(),
});

const authorEmailSchema = z.string().email().max(MAX_FIELD_LENGTH).optional().or(z.literal(''));

export const authorDataSchema = z.object({
  firstName: z.string().max(MAX_FIELD_LENGTH).optional(),
  lastName: z.string().max(MAX_FIELD_LENGTH).optional(),
  email: authorEmailSchema,
  organisation: z.string().max(MAX_FIELD_LENGTH).optional(),
});

export function isValidAuthorEmail(email: string): boolean {
  return authorEmailSchema.safeParse(email).success;
}
